import { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { ActivityIndicator } from '@kontentino/ui';
import Card from 'app/modules/analytics/components/shared/Card';

interface ReportInteractionItem {
  id: string;
  icon?: ReactNode;
  value: number;
}

interface ReportInteractionsRowCardProps {
  items: ReportInteractionItem[];
  isLoading?: boolean;
}

const ReportInteractionsRowCard: FC<ReportInteractionsRowCardProps> = ({
  items,
  isLoading = false,
}) => {
  const { t } = useTranslation();

  return (
    <div data-cy="report-interactions-row">
      <Card className="tw-items-center tw-gap-2 tw-border tw-border-grayscale-20">
        <p className="tw-w-full tw-text-center tw-text-sm tw-font-medium tw-leading-5 tw-text-grayscale-180">
          {t('analyticsPerformance.interactions')}
        </p>
        {isLoading ? (
          <div className="tw-flex tw-min-h-[30px] tw-w-full tw-items-center tw-justify-center">
            <ActivityIndicator />
          </div>
        ) : (
          <div className="tw-flex tw-w-full tw-flex-wrap tw-justify-center tw-gap-2">
            {items.map((item) => (
              <div
                key={item.id}
                className="tw-flex tw-w-10 tw-min-w-0 tw-cursor-default tw-items-center tw-justify-center tw-gap-1 tw-rounded-md tw-py-1"
                data-cy={`report-interactions-item-${item.id}`}
              >
                <span className="tw-size-[22px] tw-flex tw-shrink-0 tw-items-center tw-justify-center tw-text-grayscale-180">
                  {item.icon}
                </span>
                <span className="tw-text-sm tw-font-medium tw-leading-5 tw-text-grayscale-180">
                  {item.value}
                </span>
              </div>
            ))}
          </div>
        )}
      </Card>
    </div>
  );
};

export default ReportInteractionsRowCard;
